import React from "react";
import { Grid, Typography, Stack } from "@mui/material";
import { Link as DomLink } from "react-router-dom";

const FinishedDiamondJewelryTab = ({ links }) => {
  return (
    <Grid container>
      <Grid item xs={3}>
        <Stack direction="column" className="navbar-stack">
          <Typography className="navbar-text">Shop Finished Jewelry</Typography>
          <Stack direction="column" className="navbar-stack">
            {links.FinishedDiamondJewelryLinks.map((link, index) => (
              <a key={index} href={link.path} target="_blank" rel="noreferrer">
                {link.label}
              </a>
            ))}
          </Stack>
        </Stack>
      </Grid>
      <Grid item xs={3}>
        <Typography className="navbar-text">Outlet Store</Typography>
        <Stack direction="column" className="navbar-stack">
          {links.OutletStore.map((link, index) => (
            <a key={index} href={link.path} target="_blank" rel="noreferrer">
              {link.label}
            </a>
          ))}
        </Stack>
      </Grid>
    </Grid>
  );
};

export default FinishedDiamondJewelryTab;
